import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "bg-indigo-500 dark:bg-indigo-700 text-white py-3 flex-none w-full",
  style: {
    "background": "transparent"
  }
};
const _hoisted_2 = {
  class: "container mx-auto px-2"
};
const _hoisted_3 = {
  class: "text-center"
};
const _hoisted_4 = {
  class: "text-xs",
  style: {
    "color": "#5A7B94"
  }
};
const _hoisted_5 = {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, [_createTextVNode(_toDisplayString(_ctx.$t('FooterView.copyright')) + " ", 1), _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t('FooterView.icp')), 1)])])])]);
}